export const BUNITO_DAMAGE_REQUEST = "BUNITO_DAMAGE_REQUEST";
export const BUNITO_DAMAGE_SUCCESS = "BUNITO_DAMAGE_SUCCESS";
export const BUNITO_DAMAGE_FAILED = "BUNITO_DAMAGE_FAILED";